document.addEventListener('DOMContentLoaded', function() {
  // Check specifically for trial-offer
  if (window.location.pathname.includes('/collections/trial-offer')) {
    fetch(window.location.pathname + '/products.json')
      .then(response => response.json())
      .then(data => {
        if (data.products && data.products.length > 0) {
          const firstProductHandle = data.products[0].handle;
          const productUrl = window.location.pathname + '/products/' + firstProductHandle;
          window.location.href = productUrl;
        }
      })
      .catch(error => console.error('Error fetching products:', error));
  }
});